<template>
  <div class="row">
    <div class="col-12">
      <div class="row row-cols-1 mt-5">
        <div class="alert alert-light" role="alert">
          <p class="m-1 fs-4">{{ mainTitle }} <small class="fs-6" v-html="subTitle"></small></p>
          <div class="alert alert-info" role="alert">本資料僅作為購票預算拿捏時參考，請依據現況及自身情況斟酌調整，其他日期區間或完整資料可參考 Just.崩潰 <router-link to="/AdvSearch">付費查詢</router-link></div>
        </div>
        <small class="mt-0">
          <!-- <h2><p>台灣虎航 25夏季第一波開賣各航點價格一覽表</p></h2> -->
          <ul>
            <!-- <li>26冬季班表第一波開放訂位時間 2026/4/15 尊榮虎、2026/4/16 ~ 4/17 全體會員</li> -->
            <li>價格皆為單程未稅 TWD，票種為 tigerlight</li>
            <li>不列入 6/18 尊榮虎會員優先購票，僅針對全體會員開賣後各自算七天，也就是</li>
            <ul>
              <li>2025/6/19 開賣航線: 統計時間 6/19 10:00 ~ 6/26 23:59</li>
              <li>2025/6/20 開賣航線: 統計時間 6/20 10:00 ~ 6/27 23:59</li>
              <li>2025/9/10 開賣航線: 統計時間 9/10 17:00 ~ 9/17 23:59 (高雄＝札幌)</li>
            </ul>
            <li>2026農曆春節: 2026/2/14 ~ 2/22，數據提供範圍 2026/2/12 ~ 2/24</li>
            <!-- <li>2027農曆春節: 2027/2/4 ~ 2/10（預估，正式放假日期以六月底行政院人事總處公告為準）</li> -->
          </ul>
        </small>
        <div class="d-flex align-items-center justify-content-center">
          <div class="">
            <iframe src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQqMwrBcJN6BsIAdCrvHb9syoXKnJHFoSMBpBcXmWMx-xoJwnsouP81gKKiKOv38gn5Azmp46W5JIRh/pubhtml?widget=true&amp;headers=false" width="100%" height="100%" id="mainframe" marginheight="0" marginwidth="0" onload="this.width=screen.width;this.height=screen.height+200;" scrolling="yes"></iframe>
          </div>
        </div>
      </div>
      <!-- <template>
        <div class="ad-container">
          <Adsense data-ad-client="ca-pub-2965351057490665" data-ad-slot="5295990485" data-ad-format="auto" data-full-width-responsive="true"> </Adsense>
        </div>
      </template> -->
    </div>
  </div>
</template>

<script>
  export default {
    name: "StatW25CNY",
    data() {
      return {
        mainTitle: "(期間限定開放) 台灣虎航 2026 農曆春節期間各班次歷史逐日均價情形（首7日平均）",
        // subTitle: '<span class="fs-1 text-danger">2026 農曆春節</span> ',
        subTitle: "",
      }
    },
    mounted: async function () {
      // this.$confirm("資料已於 6/23 中午結束閱覽，如有需要請參考本站付費查詢項目，是否要前往了解？").then(() => {
      //   window.location.href = "https://www.facebook.com/just.bk.me/posts/967596972205081"
      //   // Cookies.set("disable_fareCal_hint", true, { expires: 7, secure: true })
      // })
    },
  }
</script>
